import { authRoles } from 'app/auth';
import i18next from 'i18next';

import ModelValidationEditForm from './editform/ModelValidationEditForm';
import ModelValidationTable from './table/ModelValidationTable';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'modelValidation', en);
i18next.addResourceBundle('hu', 'modelValidation', hu);

export default [
	{
		path: '/model-validation/edit/:id/:tabKey?',
		component: ModelValidationEditForm,
		auth: authRoles.modelValidation
	},
	{
		path: '/model-validation/:sessionNameParam?',
		component: ModelValidationTable,
		auth: authRoles.modelValidation
	}
];